import { jsx as a, jsxs as N } from "react/jsx-runtime";
import { useState as p, useMemo as T, useContext as d, useEffect as j } from "react";
import { identity as D } from "../util/index.js";
import { ChartCoreContext as m } from "./ChartCoreContext.js";
import { DonutChartContext as g } from "./DonutChartContext.js";
import { ChartLegend as k } from "./Legend.js";
import { ChartTooltip as I } from "./Tooltip.js";
import { TooltipContext as K } from "./TooltipContext.js";
import { constructCategoryColors as M, AvailableChartColors as f, getColorClassName as z } from "./chartUtils.js";
import { ResponsiveContainer as B, PieChart as E, Pie as _, Tooltip as $ } from "recharts";
import { twMerge as q } from "tailwind-merge";
const F = ({
  data: o = [],
  value: t,
  index: e,
  colors: n = f,
  variant: c = "donut",
  valueFormatter: i = (l) => l.toString(),
  onValueChange: s,
  children: r
}) => {
  const [l, v] = p(void 0), [u, L] = p(!0), [h, w] = p(void 0), [y, P] = p(), C = Array.from(new Set(o.map((b) => b[e]))), x = M(C, n), A = D, R = T(() => ({
    variant: c,
    activeIndex: h,
    value: t,
    titleNode: y,
    setTitleNode: P,
    setActiveIndex: w,
    onValueChange: s
  }), [c, h, t, y, s]), S = T(
    () => ({
      activeLegend: l,
      isTooltipActive: u,
      index: e,
      categories: C,
      data: o,
      valueFormatter: i,
      categoryColors: x,
      selectCategory: A,
      setIsTooltipActive: L,
      setActiveLegend: v
    }),
    [
      l,
      C,
      x,
      o,
      e,
      u,
      A,
      i
    ]
  );
  return /* @__PURE__ */ a(m.Provider, { value: S, children: /* @__PURE__ */ a(g.Provider, { value: R, children: r }) });
}, G = (o) => {
  const { className: t, children: e, ...n } = o, { value: c, variant: i, titleNode: s } = d(g), { index: r, data: l, categoryColors: v } = d(m), u = i === "donut";
  return /* @__PURE__ */ N("div", { className: q("relative h-40 w-40", t), ...n, children: [
    s && /* @__PURE__ */ a("div", { className: "absolute left-[50%] top-[50%] -translate-x-1/2 -translate-y-1/2", children: s }),
    /* @__PURE__ */ a(B, { className: "size-full", children: /* @__PURE__ */ N(E, { className: "m-auto", children: [
      /* @__PURE__ */ a(
        _,
        {
          className: "stroke-white outline-none [&_.recharts-pie-sector]:outline-none",
          data: U(l, v, r),
          cx: "50%",
          cy: "50%",
          startAngle: 90,
          endAngle: -270,
          innerRadius: u ? "75%" : "0%",
          outerRadius: "100%",
          stroke: "",
          strokeLinejoin: "round",
          dataKey: c,
          nameKey: r,
          isAnimationActive: !1
        }
      ),
      e
    ] }) })
  ] });
}, H = (o) => {
  const { categories: t = [] } = d(m), e = t.map((n) => ({
    type: void 0,
    value: n
  }));
  return /* @__PURE__ */ a(k, { payload: e, ...o });
}, J = (o) => {
  const { children: t, ...e } = o, { index: n, categoryColors: c } = d(m);
  return /* @__PURE__ */ a(
    $,
    {
      isAnimationActive: !1,
      content: (i) => {
        const s = i.payload.map((r) => ({
          category: r.payload[n],
          value: r.value,
          color: c.get(r.payload[n])
        }));
        return /* @__PURE__ */ a(K.Provider, { value: i, children: t || /* @__PURE__ */ a(I, { payload: s }) });
      },
      ...e
    }
  );
}, O = (o) => {
  const { children: t } = o, { data: e, valueFormatter: n = D } = d(m), { variant: c, value: i, setTitleNode: s } = d(g), r = !t || typeof t == "string";
  return j(() => {
    s(r ? void 0 : t);
  }, [t, r, s]), !r || c === "pie" ? null : /* @__PURE__ */ a("text", { className: "fill-gray-700", x: "50%", y: "50%", textAnchor: "middle", dominantBaseline: "middle", children: t || n(W(e, i)) });
}, Q = (o) => o.reduce((t, e) => t + e, 0), U = (o, t, e) => o.map((n) => ({
  ...n,
  color: t.get(n[e]) || f[0],
  className: z(
    t.get(n[e]) || f[0],
    "fill"
  )
})), W = (o, t) => Q(o.map((e) => e[t])), it = F, ct = G, lt = J, dt = O, mt = H;
export {
  ct as Content,
  F as DonutChart,
  G as DonutContent,
  H as DonutLegend,
  O as DonutTitle,
  J as DonutTooltip,
  mt as Legend,
  it as Root,
  dt as Title,
  lt as Tooltip
};
